/**
 * Request a Quote
 * - Visible options open enquiry modal
 * - Modal submits the Shopify contact form normally (page reload), so
 *   Shopify's own hCaptcha handles the check
 * - Files: uploaded to Uploadcare in the background when chosen; the contact
 *   email receives a download URL. Uses the merchant public key from Theme
 *   settings, or Uploadcare's demopublickey so uploads work out of the box.
 */
(function () {
  'use strict';

  var MAX_BYTES_LOCAL = 1024 * 1024;
  var MAX_BYTES_HOSTED = 10 * 1024 * 1024;
  var ALLOWED_EXT = /\.(jpe?g|png|pdf|svg)$/i;
  var ALLOWED_MIME = /^(image\/jpeg|image\/png|application\/pdf|image\/svg\+xml)$/i;

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function formatBytes(n) {
    if (n < 1024) return n + ' B';
    if (n < 1024 * 1024) return (n / 1024).toFixed(n < 10 * 1024 ? 1 : 0) + ' KB';
    return (n / (1024 * 1024)).toFixed(2) + ' MB';
  }

  function describeFile(file) {
    return file.name + ' (' + formatBytes(file.size) + ')';
  }

  function validateFile(file, maxBytes) {
    if (!file) return '';
    if (file.size > maxBytes) {
      throw new Error(
        '"' + file.name + '" is larger than ' + formatBytes(maxBytes) + '. Please compress it or email the file separately.'
      );
    }
    if (!ALLOWED_EXT.test(file.name) && !(file.type && ALLOWED_MIME.test(file.type))) {
      throw new Error('"' + file.name + '" must be JPEG, PNG, PDF or SVG.');
    }
    return describeFile(file);
  }

  function uploadToUploadcare(file, publicKey) {
    var body = new FormData();
    body.append('UPLOADCARE_PUB_KEY', publicKey);
    body.append('UPLOADCARE_STORE', '1');
    body.append('file', file, file.name);

    return fetch('https://upload.uploadcare.com/base/', {
      method: 'POST',
      body: body
    }).then(function (res) {
      return res.json().then(function (data) {
        if (!res.ok || !data || !data.file) {
          var msg = (data && (data.error || data.detail)) || 'Upload failed. Please try again or email the file.';
          throw new Error(typeof msg === 'string' ? msg : 'Upload failed. Please try again or email the file.');
        }
        return 'https://ucarecdn.com/' + data.file + '/';
      });
    });
  }

  function setFeedback(el, type, message) {
    if (!el) return;
    el.hidden = !message;
    el.textContent = message || '';
    el.className = 'raq__feedback' + (type ? ' raq__feedback--' + type : '');
  }

  function validateSelects(root) {
    var selects = root.querySelectorAll('[data-raq-option][required]');
    for (var i = 0; i < selects.length; i++) {
      if (!selects[i].value) {
        if (typeof selects[i].reportValidity === 'function') {
          selects[i].reportValidity();
        }
        selects[i].focus();
        return false;
      }
    }
    return true;
  }

  function syncOptions(root, form) {
    var selects = root.querySelectorAll('[data-raq-option]');
    for (var i = 0; i < selects.length; i++) {
      var key = selects[i].getAttribute('data-raq-option');
      var hidden = form.querySelector('[data-raq-sync="' + key + '"]');
      if (hidden) hidden.value = selects[i].value || '';
    }
  }

  function syncFileNotes(form) {
    var artwork = form.querySelector('[data-raq-artwork-meta]');
    var logo = form.querySelector('[data-raq-logo-meta]');
    var artworkUrl = form.querySelector('[data-raq-artwork-url]');
    var logoUrl = form.querySelector('[data-raq-logo-url]');
    var body = form.querySelector('[name="contact[body]"]');
    if (!body) return;

    var lines = [];
    if (artwork && artwork.value) {
      lines.push('Artwork: ' + artwork.value + (artworkUrl && artworkUrl.value ? ' — ' + artworkUrl.value : ''));
    }
    if (logo && logo.value) {
      lines.push('Logo: ' + logo.value + (logoUrl && logoUrl.value ? ' — ' + logoUrl.value : ''));
    }
    if (!lines.length) return;

    var hasLinks = (artworkUrl && artworkUrl.value) || (logoUrl && logoUrl.value);
    if (!hasLinks) {
      lines.push('File selected but upload link was not ready — ask the customer to resend the artwork.');
    }

    var marker = '[Artwork note]';
    var current = body.value || '';
    if (current.indexOf(marker) !== -1) {
      current = current.replace(/\n\n\[Artwork note\][\s\S]*$/, '');
    }
    body.value = (current ? current.replace(/\s+$/, '') + '\n\n' : '') + marker + '\n' + lines.join('\n');
  }

  function protectCaptcha(form) {
    try {
      if (window.Shopify && window.Shopify.captcha && typeof window.Shopify.captcha.protect === 'function') {
        window.Shopify.captcha.protect(form);
      }
    } catch (err) {}
  }

  function enhanceSelect(select) {
    if (!select || select.getAttribute('data-raq-dd') === '1') return;
    select.setAttribute('data-raq-dd', '1');
    select.classList.add('raq__select--enhanced');

    var wrap = document.createElement('div');
    wrap.className = 'raq-dd';
    wrap.setAttribute('data-raq-dd-root', '');

    var trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'raq-dd__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox');
    trigger.setAttribute('aria-expanded', 'false');

    var valueEl = document.createElement('span');
    valueEl.className = 'raq-dd__value is-placeholder';
    valueEl.textContent = 'Please choose';

    var chevron = document.createElement('span');
    chevron.className = 'raq-dd__chevron';
    chevron.setAttribute('aria-hidden', 'true');

    trigger.appendChild(valueEl);
    trigger.appendChild(chevron);

    var panel = document.createElement('div');
    panel.className = 'raq-dd__panel';
    panel.setAttribute('role', 'listbox');

    function syncFromSelect() {
      var selected = select.options[select.selectedIndex];
      var label = selected ? selected.textContent : 'Please choose';
      var val = select.value || '';
      valueEl.textContent = label;
      if (!val) valueEl.classList.add('is-placeholder');
      else valueEl.classList.remove('is-placeholder');

      var opts = panel.querySelectorAll('.raq-dd__option');
      for (var i = 0; i < opts.length; i++) {
        var isSel = opts[i].getAttribute('data-value') === val;
        if (isSel) opts[i].classList.add('is-selected');
        else opts[i].classList.remove('is-selected');
        opts[i].setAttribute('aria-selected', isSel ? 'true' : 'false');
      }
    }

    function close() {
      wrap.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function open() {
      var all = document.querySelectorAll('.raq-dd.is-open');
      for (var i = 0; i < all.length; i++) {
        if (all[i] !== wrap) all[i].classList.remove('is-open');
      }
      wrap.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
    }

    for (var o = 0; o < select.options.length; o++) {
      var option = select.options[o];
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'raq-dd__option';
      if (!option.value) btn.className += ' is-placeholder';
      btn.setAttribute('role', 'option');
      btn.setAttribute('data-value', option.value);
      btn.textContent = option.textContent;

      var check = document.createElement('span');
      check.className = 'raq-dd__check';
      check.setAttribute('aria-hidden', 'true');
      btn.appendChild(check);

      btn.addEventListener('click', function (event) {
        event.preventDefault();
        var next = this.getAttribute('data-value') || '';
        select.value = next;
        var changeEvent = document.createEvent('HTMLEvents');
        changeEvent.initEvent('change', true, false);
        select.dispatchEvent(changeEvent);
        syncFromSelect();
        close();
        trigger.focus();
      });

      panel.appendChild(btn);
    }

    trigger.addEventListener('click', function (event) {
      event.preventDefault();
      if (wrap.classList.contains('is-open')) close();
      else open();
    });

    select.parentNode.insertBefore(wrap, select);
    wrap.appendChild(select);
    wrap.appendChild(trigger);
    wrap.appendChild(panel);
    syncFromSelect();

    select.addEventListener('invalid', function () {
      wrap.classList.add('is-invalid');
      trigger.focus();
    });
  }

  function enhanceSelects(root) {
    var selects = root.querySelectorAll('select[data-raq-option]');
    for (var i = 0; i < selects.length; i++) {
      enhanceSelect(selects[i]);
    }

    if (document.documentElement.getAttribute('data-raq-dd-doc') === '1') return;
    document.documentElement.setAttribute('data-raq-dd-doc', '1');

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (target && target.closest && target.closest('.raq-dd')) return;
      var open = document.querySelectorAll('.raq-dd.is-open');
      for (var i = 0; i < open.length; i++) {
        open[i].classList.remove('is-open');
        var t = open[i].querySelector('.raq-dd__trigger');
        if (t) t.setAttribute('aria-expanded', 'false');
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      var open = document.querySelectorAll('.raq-dd.is-open');
      for (var i = 0; i < open.length; i++) {
        open[i].classList.remove('is-open');
      }
    });
  }

  function openModal(modal, focusEl) {
    modal.hidden = false;
    document.body.classList.add('raq-modal-open');
    var first = focusEl || modal.querySelector('input:not([type="hidden"]), textarea, select, button');
    if (first) first.focus();
  }

  function clearPostedUrl() {
    try {
      var url = new URL(window.location.href);
      url.searchParams.delete('contact_posted');
      url.hash = '';
      window.history.replaceState(window.history.state, '', url.toString());
    } catch (err) {}
  }

  function closeModal(modal) {
    modal.hidden = true;
    document.body.classList.remove('raq-modal-open');
  }

  function initRoot(root) {
    if (!root || root.getAttribute('data-raq-bound') === '1') return;
    root.setAttribute('data-raq-bound', '1');

    var openBtn = root.querySelector('[data-raq-open]');
    var modal = root.querySelector('[data-raq-modal]');
    var form = root.querySelector('form.raq__form');
    if (!openBtn || !modal || !form) return;

    enhanceSelects(root);
    protectCaptcha(form);

    var bodyWrap = form.querySelector('[data-raq-uploadcare-key]') || form.querySelector('.raq-modal__body');
    // Merchant key from Theme settings, or Uploadcare's public demo key so
    // customers can upload immediately (replace with your own for production).
    var uploadcareKey = String((bodyWrap && bodyWrap.getAttribute('data-raq-uploadcare-key')) || '').trim();
    if (!uploadcareKey) uploadcareKey = 'demopublickey';
    var maxBytes = MAX_BYTES_HOSTED;
    var pendingUploads = 0;

    var submitBtn = form.querySelector('[data-raq-submit]');
    var submitLabel = form.querySelector('[data-raq-submit-label]');
    var feedback = form.querySelector('[data-raq-feedback]');
    var artworkInput = form.querySelector('[data-raq-artwork]');
    var logoInput = form.querySelector('[data-raq-logo]');
    var artworkMeta = form.querySelector('[data-raq-artwork-meta]');
    var logoMeta = form.querySelector('[data-raq-logo-meta]');
    var artworkUrl = form.querySelector('[data-raq-artwork-url]');
    var logoUrl = form.querySelector('[data-raq-logo-url]');
    var defaultLabel = submitLabel ? submitLabel.textContent : 'Send quote request';
    var closeEls = modal.querySelectorAll('[data-raq-close]');

    function setUploading(on) {
      if (!submitBtn) return;
      if (on) {
        pendingUploads += 1;
        submitBtn.disabled = true;
        if (submitLabel) submitLabel.textContent = 'Uploading file…';
      } else {
        pendingUploads = Math.max(0, pendingUploads - 1);
        if (pendingUploads === 0) {
          submitBtn.disabled = false;
          if (submitLabel) submitLabel.textContent = defaultLabel;
        }
      }
    }

    function bindFile(input, metaField, urlField, kind) {
      if (!input) return;
      var metaUi = form.querySelector('[data-raq-file-label="' + kind + '"]');
      var wrap = input.closest('.raq__file');
      var fallback = metaUi ? metaUi.textContent : '';

      function show(file, status) {
        if (metaUi) {
          if (!file) metaUi.textContent = fallback;
          else if (status) metaUi.textContent = status;
          else metaUi.textContent = file.name;
        }
        if (wrap) {
          if (file) wrap.classList.add('is-filled');
          else wrap.classList.remove('is-filled');
        }
      }

      input.addEventListener('change', function () {
        var file = input.files && input.files[0];
        setFeedback(feedback, '', '');
        if (metaField) metaField.value = '';
        if (urlField) urlField.value = '';
        show(file);
        if (!file) return;

        var label;
        try {
          label = validateFile(file, maxBytes);
        } catch (err) {
          input.value = '';
          show(null);
          setFeedback(feedback, 'error', err.message);
          return;
        }

        if (metaField) metaField.value = label;

        if (!uploadcareKey) {
          show(file, label);
          return;
        }

        show(file, 'Uploading ' + file.name + '…');
        setUploading(true);
        uploadToUploadcare(file, uploadcareKey)
          .then(function (cdnUrl) {
            if ((input.files && input.files[0]) !== file) return;
            if (urlField) urlField.value = cdnUrl;
            show(file, '✓ ' + label);
          })
          .catch(function (err) {
            if ((input.files && input.files[0]) !== file) return;
            input.value = '';
            if (metaField) metaField.value = '';
            if (urlField) urlField.value = '';
            show(null);
            setFeedback(feedback, 'error', err.message || 'Upload failed.');
          })
          .then(function () {
            setUploading(false);
          });
      });
    }

    bindFile(artworkInput, artworkMeta, artworkUrl, 'artwork');
    bindFile(logoInput, logoMeta, logoUrl, 'logo');

    openBtn.addEventListener('click', function () {
      if (!validateSelects(root)) return;
      syncOptions(root, form);
      setFeedback(feedback, '', '');
      openModal(modal);
      protectCaptcha(form);
    });

    for (var c = 0; c < closeEls.length; c++) {
      closeEls[c].addEventListener('click', function () {
        closeModal(modal);
      });
    }

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !modal.hidden) {
        closeModal(modal);
      }
    });

    form.addEventListener('submit', function (event) {
      if (pendingUploads > 0) {
        event.preventDefault();
        setFeedback(feedback, 'error', 'Please wait for the file upload to finish.');
        return;
      }
      syncOptions(root, form);
      syncFileNotes(form);
      if (submitLabel) submitLabel.textContent = 'Sending…';
      window.setTimeout(function () {
        if (submitLabel) submitLabel.textContent = defaultLabel;
      }, 15000);
    });

    window.addEventListener('pageshow', function (event) {
      if (event.persisted && submitLabel) submitLabel.textContent = defaultLabel;
    });

    var posted = form.querySelector('[data-raq-posted]');
    if (posted) {
      var ok = posted.getAttribute('data-raq-posted') === 'success';
      openModal(modal, ok ? modal.querySelector('.raq-modal__close') : null);
      if (!ok) {
        var errors = form.querySelector('.errors');
        if (errors && errors.scrollIntoView) errors.scrollIntoView({ block: 'nearest' });
      }
      clearPostedUrl();
    }
  }

  ready(function () {
    var roots = document.querySelectorAll('[data-raq-root]');
    for (var i = 0; i < roots.length; i++) {
      initRoot(roots[i]);
    }
  });
})();
